module.exports = __webpack_public_path__ + "static/hero2-2e198bdcf428789cf27357c4d90fb16c.jpg";